"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComposedBtn = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var react_device_detect_1 = require("react-device-detect");

require("@suezenv/react-theme-components/assets/css/main.css");

var defaultProps = {
  btn1: {
    showTitleMobile: false,
    variant: 'secondary',
    isDisabled: false,
    icon: 'arrow-left',
    className: 'bg-transparent',
    classesBloc: 'offset-md-1 col-3 col-md-4'
  },
  btn2: {
    showTitleMobile: true,
    variant: 'primary',
    isDisabled: false,
    classesBloc: 'offset-4 offset-md-4 col-5 col-md-3'
  }
};

exports.ComposedBtn = function (_a) {
  var btns = _a.btns;
  return react_1.default.createElement("div", {
    className: "row"
  }, btns.map(function (btn, index) {
    var defaultPropsBtn = btn.defaultConfig ? defaultProps[btn.defaultConfig] : null;
    var showTitleM = btn.showTitleMobile !== undefined ? btn.showTitleMobile : defaultPropsBtn.showTitleMobile;
    return react_1.default.createElement("div", {
      className: defaultPropsBtn ? defaultPropsBtn.classesBloc : btn.classesBloc,
      key: index
    }, react_1.default.createElement(react_theme_components_1.SzButton, __assign({
      onClick: btn === null || btn === void 0 ? void 0 : btn.onClick
    }, defaultPropsBtn, btn), react_device_detect_1.isBrowser ? btn.title : showTitleM && btn.title));
  }));
};

exports.default = exports.ComposedBtn;